import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { NewUser } from "@/components/signup/site-activation/components/new-user/new-user";
import { SiteActivation } from "@/components/signup/site-activation/site-activation";
import { getFirstName } from "@/components/signup/utils/get-first-name";
import { useUserContext } from "@/components/user-context/user-context-provider";

import { BlueWaveTemplateJsm } from "./blue-wave-template-jsm";
import { JsmSubmitButtonNewUser } from "./jsm-submit-button-new-user";

export const LoggedInBlueWaveTemplateJsmNewUser = ({
    productEditionText
}: {
    productEditionText: string;
}) => {
    const { formatMessage } = useIntl();
    const {
        user: { name }
    } = useUserContext();

    return (
        <BlueWaveTemplateJsm productEditionText={productEditionText}>
            <div css={containerCss}>
                <h2 css={siteActivationHeadingCss}>
                    {name
                        ? formatMessage(
                              {
                                  id: "WacSignupForm.personalizedNameSiteMessage",
                                  defaultMessage:
                                      "Let's name your site, {username}"
                              },
                              { username: getFirstName(name) }
                          )
                        : formatMessage({
                              id: "JiraSoftwarePageTemplate.loggedInHero.welcomeBack",
                              defaultMessage: "Welcome back"
                          })}
                </h2>
                <p css={subheaderCss}>
                    {formatMessage({
                        id: "WacSignupForm.inputSiteNameMessage",
                        defaultMessage:
                            "Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later."
                    })}
                </p>
                <SiteActivation
                    NewUser={
                        <NewUser
                            HelperText={null}
                            SubmitButton={<JsmSubmitButtonNewUser />}
                        />
                    }
                />
            </div>
        </BlueWaveTemplateJsm>
    );
};

const containerCss = css({
    display: "grid",
    gap: "16px"
});

const siteActivationHeadingCss = css({
    fontSize: 24,
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});

const subheaderCss = css({
    fontSize: "14px",
    // eslint-disable-next-line local/ensure-wac-token-usage
    color: "#344563",
    textAlign: "center",
    margin: 0
});
